module.exports = __webpack_public_path__ + "static/img/SketchPng48e029494568d9c9a3cf3459738779b5a097820b014206c9e8176b2a4608e43c.6cc745de.png";